import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { iotGatewayEvents } from "../../data/iotGatewayEvents.data";
import { formatDateTime, getUniqueItems } from "../../utils";
import { IotGatewayEventLatestDto } from "./dtos/IotGatewayEventLatestDto";
import { useIotGatewayEvents } from "./useIotGatewayEvents";
import type {} from '@mui/x-data-grid/themeAugmentation';
import { DashboardEventsLatest } from "../../components/DashboardEventsLatest";
import { IotGatewayEventDto } from "./dtos/IotGatewayEventDto";
import { IotGatewayEvents } from "./IotGatewayEvents";
import { Dashboard } from "../../enums/Dashboard";


type DataRow = {

    id: string;
    approved : boolean;
    apUpTime : string;
    connected : boolean;
    createdOn : Date;
    gatewayEuid : string;
    gatewayName : string;
    getNetworkId : string;
    getNetworkType : string;
    getRadioChannel : number;
    getRadioTxPower : number;
    // getVlanEnable : boolean;
    // getVlanMode : string;
    ip : string;
    iotFirmware : string;
    networkExtId : string;
    networkMac : string;
    // networkStatus : string;
    // setVlanMode : string;
    status : string;
    updatedOn : Date;
    // usbPower : boolean;

};


const getColumns = ( rows: DataRow[] ): GridColDef[ ] => {

    // do not display status column if only one status was selected
    const distinctStatuses = getUniqueItems( rows.map( row => row.status ) );

    let columns: GridColDef[ ] = [ ];

    if( distinctStatuses.length === 1 ) {

        columns = [

            {
                field: 'approved',
                headerName: 'Approved',
                width: 150,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                type: 'boolean'
            },

            {
                field: 'apUpTime',
                headerName: 'Ap Up Time',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'connected',
                headerName: 'Connected',
                width: 150,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                type: 'boolean'
            },

            {
                field: 'createdOn',
                headerName: 'Created On',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                renderCell: ( params => formatDateTime( params.row.createdOn ))
            },

            {
                field: 'gatewayEuid',
                headerName: 'Gateway Euid',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'gatewayName',
                headerName: 'Gateway Name',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getNetworkId',
                headerName: 'Get Network Id',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getNetworkType',
                headerName: 'Get Network Type',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getRadioChannel',
                headerName: 'Get Radio Channel',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getRadioTxPower',
                headerName: 'Get Radio Tx Power',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            // {
            //     field: 'getVlanEnable',
            //     headerName: 'Get Vlan Enable',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center',
            //     type: 'boolean'
            // },

            // {
            //     field: 'getVlanMode',
            //     headerName: 'Get Vlan Mode',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            {
                field: 'ip',
                headerName: 'IP',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'iotFirmware',
                headerName: 'IoT Firmware',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'networkExtId',
                headerName: 'Network Ext Id',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'networkMac',
                headerName: 'Network Mac',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            // {
            //     field: 'networkStatus',
            //     headerName: 'Network Status',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            // {
            //     field: 'setVlanMode',
            //     headerName: 'Set Vlan Mode',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            {
                field: 'updatedOn',
                headerName: 'Updated On',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                renderCell: ( params => formatDateTime( params.row.updatedOn ))
            },

            // {
            //     field: 'usbPower',
            //     headerName: 'USB Power',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center',
            //     type: 'boolean'
            // },

        ];

    } else {

        columns = [

            {
                field: 'approved',
                headerName: 'Approved',
                width: 150,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                type: 'boolean'
            },

            {
                field: 'apUpTime',
                headerName: 'Ap Up Time',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'connected',
                headerName: 'Connected',
                width: 150,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                type: 'boolean'
            },

            {
                field: 'createdOn',
                headerName: 'Created On',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                renderCell: ( params => formatDateTime( params.row.createdOn ))
            },

            {
                field: 'gatewayEuid',
                headerName: 'Gateway Euid',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'gatewayName',
                headerName: 'Gateway Name',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getNetworkId',
                headerName: 'Get Network Id',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getNetworkType',
                headerName: 'Get Network Type',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getRadioChannel',
                headerName: 'Get Radio Channel',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'getRadioTxPower',
                headerName: 'Get Radio Tx Power',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            // {
            //     field: 'getVlanEnable',
            //     headerName: 'Get Vlan Enable',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center',
            //     type: 'boolean'
            // },

            // {
            //     field: 'getVlanMode',
            //     headerName: 'Get Vlan Mode',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            {
                field: 'ip',
                headerName: 'IP',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'iotFirmware',
                headerName: 'IoT Firmware',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'networkExtId',
                headerName: 'Network Ext Id',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            {
                field: 'networkMac',
                headerName: 'Network Mac',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center'
            },

            // {
            //     field: 'networkStatus',
            //     headerName: 'Network Status',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            // {
            //     field: 'setVlanMode',
            //     headerName: 'Set Vlan Mode',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center'
            // },

            {
                field: 'updatedOn',
                headerName: 'Updated On',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                renderCell: ( params => formatDateTime( params.row.updatedOn ))
            },

            // {
            //     field: 'usbPower',
            //     headerName: 'USB Power',
            //     width: 200,
            //     editable: true,
            //     headerAlign: 'center',
            //     align: 'center',
            //     type: 'boolean'
            // },

            {
                field: 'status',
                headerName: 'Status',
                width: 200,
                editable: true,
                headerAlign: 'center',
                align: 'center',
                type: 'boolean'
            },

        ];

    }

    return columns

};


const getRows = ( iotGatewayEventsLatest: IotGatewayEventLatestDto[] ) : DataRow[] => {

    const rows: DataRow[] = [];

    let index: number = 1;

    for( const iotGatewayEventLatest of iotGatewayEventsLatest ) {

        const iotGatewayEvent = iotGatewayEvents.find( be => be.event === iotGatewayEventLatest.status );

        if( !iotGatewayEvent ) {
            
            throw Error( `Iot Gateway status ${iotGatewayEventLatest.status} not found` );

        }
       
        rows.push({ 
            id: index.toString(),
            approved : iotGatewayEventLatest.approved,
            apUpTime : iotGatewayEventLatest.apUpTime,
            connected : iotGatewayEventLatest.connected,
            createdOn : iotGatewayEventLatest.createdOn,
            gatewayEuid : iotGatewayEventLatest.gatewayEuid,
            gatewayName : iotGatewayEventLatest.gatewayName,
            getNetworkId : iotGatewayEventLatest.getNetworkId,
            getNetworkType : iotGatewayEventLatest.getNetworkType,
            getRadioChannel : iotGatewayEventLatest.getRadioChannel,
            getRadioTxPower : iotGatewayEventLatest.getRadioTxPower,
            // getVlanEnable : iotGatewayEventLatest.getVlanEnable,
            // getVlanMode : iotGatewayEventLatest.getVlanMode,
            ip : iotGatewayEventLatest.ip,
            iotFirmware : iotGatewayEventLatest.iotFirmware,
            networkExtId : iotGatewayEventLatest.networkExtId,
            networkMac : iotGatewayEventLatest.networkMac,
            // networkStatus : iotGatewayEventLatest.networkStatus,
            // setVlanMode : iotGatewayEventLatest.setVlanMode,
            status : iotGatewayEventLatest.status,
            updatedOn : iotGatewayEventLatest.updatedOn,
            // usbPower : iotGatewayEventLatest.usbPower,

        });

        ++index;

    }

    return rows;

};


type IotGatewayEventsLatestProps = {

    events: string[];
    refreshCount: number;
    villageCode: string;

};


export const IotGatewayEventsLatest : React.FC< IotGatewayEventsLatestProps > = ( props : IotGatewayEventsLatestProps ) => {

    const { events, refreshCount, villageCode  } = props;

    const [ areIotGatewayEventsLatestLoading, setAreIotGatewayEventsLatestLoading ] = useState<boolean>( false );
    const [ iotGatewayEventDtos, setIotGatewayEventDtos ] = useState<IotGatewayEventDto[]>( [] );
    const [ columns, setColumns ] = useState< GridColDef[ ] >( [ ] );
    const [ displayIotGatewayEvents, setDisplayIotGatewayEvents ] = useState( false );
    const [ gatewayName, setGatewayName ] = useState<string>( '' );
    const [ isChildLoading, setIsChildLoading ] = useState( false );
    const [ rows, setRows ] = useState<DataRow[ ]>( [ ] );

    const style = {

        // width: ( columns.length === 7 ) ? 1250 : 1400
        // marginLeft: '50px !important',
        // marginRight: '50px !important'
        width: '80%'

    };

    
    const { getIotGatewayEvents, getIotGatewayEventsLatest } = useIotGatewayEvents( );

    useEffect( ( ) => {

        if( events.length === 0 || !villageCode ) {

            setRows( [] );
            return;

        }

        const fetchIotGatewayEventsLatest = async( ) => {

            if( refreshCount === 0 ) {
            
                setAreIotGatewayEventsLatestLoading( true );

            }

            const batteryEventsLatest = await getIotGatewayEventsLatest( villageCode, events );

            if( refreshCount === 0 ) {
                
                setAreIotGatewayEventsLatestLoading( false );

            }

            if( batteryEventsLatest ) {

                const rows = getRows( batteryEventsLatest );
                
                setRows( rows );

                const columns = getColumns( rows );
                setColumns( columns );

            }

        };

        fetchIotGatewayEventsLatest( );

    }, [ events, refreshCount, villageCode ]);


    const selectRowHandler = async ( rowId: string ) => {

        const row = rows.find( r => r.id === rowId );

        if( !row  ) {

            throw Error( `Cannot find row with id = ${rowId}` );

        }
    
        setIsChildLoading( true );
        const iotGatewayEventDtos = await getIotGatewayEvents( row.networkMac, villageCode );
        setIsChildLoading( false );

        if( !iotGatewayEventDtos ) {

            return;

        }

        setIotGatewayEventDtos( iotGatewayEventDtos );
        setGatewayName( row.gatewayName );
        setDisplayIotGatewayEvents( true );

    };


    const handleClose = ( ) => setDisplayIotGatewayEvents( false );

    

    return(

        <>

            <DashboardEventsLatest 
                
                columns={ columns } 
                dashboard={ Dashboard.IotGateway }
                isChildLoading={ isChildLoading } 
                isParentLoading={ areIotGatewayEventsLatestLoading } 
                rows={ rows }
                selectRow={ selectRowHandler }
                sortField="createdOn"
                style={ style } 
            />

            <IotGatewayEvents displayIotGatewayEvents={displayIotGatewayEvents} gatewayName={gatewayName} onClose={handleClose} iotGatewayEventDtos={iotGatewayEventDtos} />

        </>

    );


};